// src/auth.js
// -----------------------------------------------------------------------------
// Aide pour gérer le token de session (JWT) côté client.
//
// ⚠️ Important : decodePayload() lit juste le contenu du token (rôle, date
// d'expiration) pour adapter l'interface (afficher/masquer des liens,
// rediriger si pas connecté). Ce n'est PAS une vérification de signature —
// impossible à faire correctement côté navigateur sans exposer le secret.
// La vraie vérification a lieu côté serveur (auth.js, requireAuth) à chaque
// appel d'une route protégée. Le contrôle ici sert uniquement à l'affichage,
// jamais à protéger une donnée sensible par lui-même.

const TOKEN_KEY = "token";

export function getToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}

function decodePayload(token) {
    try {
        const [, payloadB64] = token.split(".");
        const json = atob(payloadB64.replace(/-/g, "+").replace(/_/g, "/"));
        return JSON.parse(json);
    } catch {
        return null;
    }
}

// Renvoie { username, role } si le token est présent et pas expiré, sinon null.
export function getSession() {
    const token = getToken();
    if (!token) return null;

    const payload = decodePayload(token);
    if (!payload) return null;

    if (payload.exp && Date.now() >= payload.exp * 1000) {
        clearToken(); // session expirée : on nettoie pour éviter les faux positifs
        return null;
    }

    return { username: payload.sub, role: payload.role };
}

export function isLoggedIn() {
    return getSession() !== null;
}

// À utiliser dans les headers fetch : { ...authHeader() }
export function authHeader() {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}